<template>
  <base-viewer>
    <v-app-bar color="primary" fixed dark style="margin-left:256px">
      <v-toolbar-title>用户中心 - {{$route.meta.title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <!--DEISABLED-->
          <v-btn disabled icon v-on="on" @click="reloadData()">
            <v-icon dark>cached</v-icon>
          </v-btn>
        </template>
        <span>刷新当前页面</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" to="/">
            <v-icon dark>home</v-icon>
          </v-btn>
        </template>
        <span>返回官网首页</span>
      </v-tooltip>
    </v-app-bar>
    <navDrawer />
    <v-content style="padding: 62px 0 0px 256px">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
    <Footer style="margin-left:256px" />
  </base-viewer>
</template>
<script>
import Footer from "@/core/components/footer.vue";
import navDrawer from "@/core/components/navigation";

import mjp from "@/plugins/makjust";

export default {
  components: {
    Footer,
    navDrawer
  },
  created() {
    mjp.getMe(this.$store.state.USER.sessionToken).then(r => {
      this.$store.dispatch("saveUserAsync", r.data);
    });
    this.$store.commit("initUserInfo", window.localStorage);
  },
  inject:['reloadData'],
};
</script>